module.exports = __webpack_public_path__ + "resources/img/img_ahnlabv3_net_server_m_jp.355013439da95a1116d662bb71ddeaa4.png";